import { useQuery } from "@msuite/ui/query";
import { Timeline } from "@msuite/ui/timeline";
import { responseHandler } from "@msuite/ui/utils";
import type { TicketTimelineItem as TicketTimelineItemType } from "@msuite/utils/types";
import { client } from "@/hono";
import { TicketTimelineItem } from "./ticket-timeline-item";

/** Props Interface */
interface TicketTimelineProps {
	ticketId: string;
}

export function TicketTimeline({ ticketId }: TicketTimelineProps) {
	/** Hooks */

	/** Query */
	// The route is ungated — reading a ticket is every member's, and the policies scope the
	// answer to the caller's organisation, so the history simply comes back empty for a ticket
	// the caller cannot reach.
	const {
		data: timeline,
		isLoading,
		refetch,
	} = useQuery({
		queryKey: ["tickets", ticketId, "timeline"],
		queryFn: async () => {
			const response = await client.tickets[":ticketId"].timeline.$get({
				param: { ticketId },
			});
			const data = await responseHandler(response);
			return data.timeline;
		},
	});

	/** Render */
	return (
		<div className="shrink-0 h-[400px]">
			<Timeline
				timeline={timeline}
				renderItem={(type, item) => {
					if (type === "ticket") {
						return <TicketTimelineItem item={item as TicketTimelineItemType} />;
					}
				}}
				isLoading={isLoading}
				refetch={refetch}
			/>
		</div>
	);
}
